import { render, staticRenderFns } from "./IconCommunityChat.vue?vue&type=template&id=5ebd5ae6&scoped=true"
import script from "./IconCommunityChat.vue?vue&type=script&lang=js"
export * from "./IconCommunityChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebd5ae6",
  null
  
)

export default component.exports